import {
  ApolloClient,
  ApolloLink,
  from,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { localStorageKeys } from '../';
import { http } from './config';

const httpLink = new HttpLink(http);

const authMiddleware = new ApolloLink((operation, forward) => {
  const authHeader = localStorage.getItem(localStorageKeys.idToken)
    ? { authorization: localStorage.getItem(localStorageKeys.idToken) }
    : {};
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...authHeader,
    },
  }));
  return forward(operation);
});

const cache = new InMemoryCache({
  addTypename: false,
});

const client = new ApolloClient({
  link: from([authMiddleware, httpLink]),
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'none',
    },
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'none',
    },
  },
});

export default client;
